"use client";

import type { CSSProperties } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";
const LOCKUP_SRC = {
  light: "/Wilson_by_Cartage_Black.svg",
  dark: "/Wilson_by_Cartage_White.svg"
} as const;
const ASPECT = 279 / 75;
export function WilsonLockup({
  height = 22,
  className,
  style
}: {
  height?: number;
  className?: string;
  style?: CSSProperties;
}) {
  const {
    resolvedTheme
  } = useTheme();
  const src = resolvedTheme === "dark" ? LOCKUP_SRC.dark : LOCKUP_SRC.light;
  return <Image src={src} alt="" aria-hidden="true" width={Math.round(height * ASPECT)} height={height} className={cn("shrink-0 select-none", className)} style={style} draggable={false} data-sentry-element="Image" data-sentry-component="WilsonLockup" data-sentry-source-file="WilsonLockup.tsx" />;
}